import { Search, compareSearch, defaultSearch } from "@/utilities/types/search";

import { localStorageGetArray, localStorageStoreIterable } from ".";


type RecentSearches = Array<Search>;

const KEY_RECENT_SEARCHES = "search";
const MAX_ENTRIES = 10;

export const getRecentSearches = (): RecentSearches => {
    const searches: RecentSearches = localStorageGetArray(KEY_RECENT_SEARCHES);

    return searches.filter((search)=>search.searchType === 0);
};

export const storeRecentSearch = (newSearch: Search): void => {
    const recentSearches = getRecentSearches();

    if (!compareSearch(newSearch, defaultSearch)) {
        const newSearches = recentSearches.filter((search)=>{
            return !compareSearch(search, newSearch);
        });

        newSearches.push(newSearch);

        localStorageStoreIterable(KEY_RECENT_SEARCHES, newSearches, { maxEntries: MAX_ENTRIES });
    }
};

export const deleteRecentSearch = (newSearch: Search): Array<Search> => {
    const recentSearches = getRecentSearches();

    const newSearches = recentSearches.filter((search)=>{
        return !compareSearch(search, newSearch);
    });

    localStorageStoreIterable(KEY_RECENT_SEARCHES, newSearches, { maxEntries: MAX_ENTRIES });

    return newSearches;
};
